import React from 'react';
import FindReplaceToolbarButtonWithState from './FindReplaceToolbarButtonWithState';
import keymapPlugin from './pm-plugins/keymap';
import { createPlugin } from './pm-plugins/main';
import { findReplacePluginKey } from './pm-plugins/plugin-key';
export var findReplacePlugin = function findReplacePlugin(_ref) {
  var props = _ref.config,
    api = _ref.api;
  return {
    name: 'findReplace',
    pmPlugins: function pmPlugins() {
      return [{
        name: 'findReplace',
        plugin: function plugin(_ref2) {
          var dispatch = _ref2.dispatch;
          return createPlugin(dispatch);
        }
      }, {
        name: 'findReplaceKeymap',
        plugin: function plugin() {
          var _api$analytics;
          return keymapPlugin(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions);
        }
      }];
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return undefined;
      }
      return findReplacePluginKey.getState(editorState) || undefined;
    },
    actions: {
      getToolbarButton: function getToolbarButton(_ref3) {
        var popupsBoundariesElement = _ref3.popupsBoundariesElement,
          popupsMountPoint = _ref3.popupsMountPoint,
          popupsScrollableElement = _ref3.popupsScrollableElement,
          editorView = _ref3.editorView,
          containerElement = _ref3.containerElement,
          dispatchAnalyticsEvent = _ref3.dispatchAnalyticsEvent,
          isToolbarReducedSpacing = _ref3.isToolbarReducedSpacing;
        return /*#__PURE__*/React.createElement(FindReplaceToolbarButtonWithState, {
          popupsBoundariesElement: popupsBoundariesElement,
          popupsMountPoint: popupsMountPoint,
          popupsScrollableElement: popupsScrollableElement,
          editorView: editorView,
          containerElement: containerElement,
          dispatchAnalyticsEvent: dispatchAnalyticsEvent,
          isToolbarReducedSpacing: isToolbarReducedSpacing,
          api: api
        });
      }
    },
    primaryToolbarComponent: function primaryToolbarComponent(_ref4) {
      var popupsBoundariesElement = _ref4.popupsBoundariesElement,
        popupsMountPoint = _ref4.popupsMountPoint,
        popupsScrollableElement = _ref4.popupsScrollableElement,
        isToolbarReducedSpacing = _ref4.isToolbarReducedSpacing,
        editorView = _ref4.editorView,
        containerElement = _ref4.containerElement,
        dispatchAnalyticsEvent = _ref4.dispatchAnalyticsEvent;
      if (props !== null && props !== void 0 && props.twoLineEditorToolbar) {
        return null;
      } else {
        return /*#__PURE__*/React.createElement(FindReplaceToolbarButtonWithState, {
          popupsBoundariesElement: popupsBoundariesElement,
          popupsMountPoint: popupsMountPoint,
          popupsScrollableElement: popupsScrollableElement,
          isToolbarReducedSpacing: isToolbarReducedSpacing,
          editorView: editorView,
          containerElement: containerElement,
          dispatchAnalyticsEvent: dispatchAnalyticsEvent,
          takeFullWidth: props === null || props === void 0 ? void 0 : props.takeFullWidth,
          api: api
        });
      }
    }
  };
};